module.exports = __webpack_public_path__ + "static/img/tokyomarathon.485d0d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tmf/tokyomarathon.svg
// module id = md/Q
// module chunks = 1